var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm.caption != undefined
      ? _c("div", [_vm._v(_vm._s(_vm.caption))])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row mt-4" },
      _vm._l(_vm.selectedCourseTypes, function(courseType) {
        return _c("actual-groups-of-one-type", {
          key: courseType.value,
          staticClass: "col-12 col-sm-6 col-md-4 col-lg-3 mb-4",
          attrs: {
            "show-next-groups": _vm.showNextGroups,
            "old-groups-count": _vm.oldGroupsCount,
            "course-type": courseType
          },
          on: { "select-course-group": _vm.selectCourseGroup }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }